import type { PinOnImageResult } from '@core-api/presentation/types/response';
import { useFetchPinOnImageResults } from '@mentimeter/presentation-data-hooks/fetch-pin-on-image-results';

interface UsePinOnImageResultsParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
}

export const usePinOnImageResults = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults,
  sessionId,
}: UsePinOnImageResultsParams): {
  results: PinOnImageResult[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useFetchPinOnImageResults({
    adminKey,
    interactiveContentId,
    shouldFetchResults,
    sessionId,
  });

  return {
    results: data?.results ?? [],
    isLoading,
  };
};
